import { MultiSelect } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useOfertasFilterContext } from '../../context/ofertas-filter-context';
import { CarlineWithOfertas, FilterTypes, Oferta } from '../../services/ofertas-service/models/ofertas';

export const MobileSelector = ({
	carlines,
	activeCarlineIndex,
	setSelectedOferta,
	carlineSelectedURLRef,
}: {
	carlines: CarlineWithOfertas[];
	activeCarlineIndex: number;
	setSelectedOferta: (oferta: Oferta) => void;
	carlineSelectedURLRef: React.MutableRefObject<boolean>;
}): React.ReactElement => {
	const {
		handleFilteredCarlines,
		selectedGamaFilter,
		selectedMotorizacionFilter,
		setSelectedGamaFilter,
		setSelectedMotorizacionFilter,
		setActiveCarlineIndex,
		anchorScrollOnFilter,
		mobileFilterOptions,
	} = useOfertasFilterContext();

	const carlinesMap: { [key: string]: React.ReactNode } = Object.fromEntries(
		carlines.map((carline, index) => [String(index), `${carline.nuevo ? 'NUEVO ' : ''}${carline.title.toUpperCase()}`]),
	);

	const handleSelectOnChange = (value: string | string[]) => {
		const carlineValue = Array.isArray(value) ? value[0] : value;

		const foundCarline = Object.entries(carlinesMap).find(([, label]) => String(label) === String(carlineValue))?.[0];

		const selectedIndex = Number(foundCarline);
		const selectedCarline = carlines[selectedIndex];

		if (!selectedCarline) {
			return;
		}

		setActiveCarlineIndex(selectedIndex);

		const ofertas = selectedCarline.ofertas;

		//Esto hace que se añada el coche seleccionado a la url
		carlineSelectedURLRef.current = true;

		if (Array.isArray(ofertas) && ofertas.length > 0) {
			setSelectedOferta(ofertas[0]);
		}
	};

	const handleFilterChange = (optionKey: string) => {
		const currentFilters = getDefaultFilters();

		anchorScrollOnFilter();
		handleFilteredCarlines(optionKey);

		if (currentFilters.includes(optionKey)) {
			if ([FilterTypes.PROFESIONAL, FilterTypes.LIFESTYLE].includes(optionKey as FilterTypes)) {
				setSelectedGamaFilter(null);
			} else {
				setSelectedMotorizacionFilter(null);
			}
		} else {
			if ([FilterTypes.PROFESIONAL, FilterTypes.LIFESTYLE].includes(optionKey as FilterTypes)) {
				setSelectedGamaFilter(optionKey);
			} else {
				setSelectedMotorizacionFilter(optionKey);
			}
		}
		setActiveCarlineIndex(0);
	};

	const getDefaultFilters = () => {
		const defaults = [];
		if (selectedGamaFilter) defaults.push(selectedGamaFilter);
		if (selectedMotorizacionFilter) defaults.push(selectedMotorizacionFilter);
		return defaults;
	};

	const shouldShowFilters = () => {
		return mobileFilterOptions.length > 0;
	};

	const dinamicLabel = () => {
		if (mobileFilterOptions.length == 1) {
			return mobileFilterOptions[0].groupTitle;
		} else {
			return 'Filtros';
		}
	};

	return (
		<div style={{ display: 'flex', gap: '5px' }}>
			{shouldShowFilters() && (
				<div style={{ flex: '1' }}>
					<MultiSelect
						name="filterSelector"
						label={dinamicLabel()}
						options={mobileFilterOptions}
						value={getDefaultFilters()}
						onOptionClick={handleFilterChange}
						onChange={() => {}}
					/>
				</div>
			)}

			<div style={{ flex: '1' }}>
				<MultiSelect
					name="selectedCarline"
					isFloating
					singleOptionMode
					defaultSingleOption={String(carlinesMap[String(activeCarlineIndex)] ?? '')}
					options={carlinesMap}
					onChange={handleSelectOnChange}
				/>
			</div>
		</div>
	);
};
